import type { RouteLocationNormalized, RouteRecordRaw } from 'vue-router'

export const launchAdminRouter: RouteRecordRaw[] = [
  {
    children: [
      {
        component: async () => import('../views/LaunchPortalView.vue'),
        meta: {
          authZ: ({ user }) => user.hasRole('pb:super'),
          title: 'launch.dashboard',
        },
        name: 'admin.launch',
        path: '',
      },
      {
        component: async () => import('../components/LaunchMessagesInbox.vue'),
        meta: {
          roles: ['pb:super'],
          title: 'launch.gmessenger',
        },
        name: 'admin.launch.messenger',
        path: 'messenger',
        props: {
          standalone: true,
        },
      },
      {
        component: async () => import('../views/LaunchAdminBrandView.vue'),
        meta: {
          authZ: ({ user }) => user.hasRole('pb:super'),
          title: 'launch.dashboard',
        },
        name: 'admin.launch.brand',
        path: 'brands/:brandId',
        props: (route: RouteLocationNormalized) => ({
          brandId: route.params.brandId,
        }),
      },
    ],
    component: async () => import('../views/LaunchAdminView.vue'),
    meta: {
      authZ: ({ user }) => user.hasRole('pb:super'),
    },
    path: 'admin/launch',
  },
]
